import React from 'react';
import NewsSourceLink from './NewsSourceLink';

const NewsStudentBrief = ({ brief, source }) => {
  if (!brief?.text) return null;
  const word = brief.word || {};
  return (
    <section id="student" className="news-section" aria-labelledby="news-student-title">
      <h2 id="news-student-title" className="news-section-title">아침 조회 3분 시사</h2>
      <div className="news-card news-student">
        <p className="news-eyebrow">학생들에게 이렇게 읽어 주세요</p>
        <p className="news-student-text">{brief.text}</p>
        {word.term && (
          <p className="news-student-word">
            <strong>오늘의 낱말</strong>
            <span>{word.term}</span>
            {word.meaning && <small>{word.meaning}</small>}
          </p>
        )}
        {brief.question && (
          <div className="news-student-question">
            <span>짝과 30초 이야기해요</span>
            <p>{brief.question}</p>
          </div>
        )}
        <NewsSourceLink source={source} />
      </div>
    </section>
  );
};

export default NewsStudentBrief;
